module.exports = __webpack_public_path__ + "img/footer-ph2.2b86aac3.png";